
























import { Component, Prop, Vue } from 'nuxt-property-decorator'
import ComponentImage from '~/components/images/image.vue'
import { IStyle } from '~/assets/interfaces/classes'
import { filterDate } from '~/assets/filters/date'
import { IArticle } from '~/assets/interfaces/articles'

@Component({
  components: {
    ComponentImage,
  },
  filters: {
    filterDate,
  },
})
export default class ComponentArticleItem extends Vue {
  @Prop({
    type: Object,
    default: () => {},
  })
  private item!: IArticle

  private mounted(): void {
    this.$emit('loaded')
  }

  private $style!: IStyle

  private get classImage() {
    return {
      [this.$style.image]: true,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
    }
  }

  private get classTitle() {
    return {
      [this.$style.title]: true,
      [this.$style.mobile]: this.$device.isMobileOrTablet,
      [this.$style.desktop]: !this.$device.isMobileOrTablet,
    }
  }
}
